import * as React from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
//import { checkTokenExpiration } from "../auth/tokenUtils";
import { useEffect } from "react";

const AuthCallback = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [processed, setProcessed] = React.useState(false);

  useEffect(() => {
   
    if (processed) {
      return;
    }

    const handleAuthCallback = async () => {
      try {
      
        const response = await instance.handleRedirectPromise()
        
        if (response) {    
        
          const sessionKeys = Object.keys(localStorage);
         
          
          const msalKeys = sessionKeys.filter(key => key.includes('msal'));
       
          
          if (msalKeys.length === 0) {
          } else {
       
            msalKeys.forEach(key => {
              const value = localStorage.getItem(key);
         
            });
          }
         
          const accounts = instance.getAllAccounts();
        
           instance.setActiveAccount(accounts[0]);
       //   const hasValidTokens = checkTokenExpiration(instance);
       
          setProcessed(true);
         
          setTimeout(() => {
            navigate("/HomePage", { replace: true });
          }, 1000);
          
        } else {
          
          const accounts = instance.getAllAccounts();
          

          if (accounts.length > 0) {
             instance.setActiveAccount(accounts[0]);
            setProcessed(true);
            navigate("/HomePage", { replace: true });
          } else {
            
            setProcessed(true);
            setTimeout(() => {
              navigate("/", { replace: true });
            }, 1000);
          }
        }
      } catch (error) {
       
        const sessionKeys = Object.keys(localStorage);
        const msalKeys = sessionKeys.filter(key => key.includes('msal'));
        
        setProcessed(true);
        setTimeout(() => {
          navigate("/", { replace: true });
        }, 2000);
      }
    };

    handleAuthCallback();
  }, [instance, navigate, processed]);

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '18px',
      fontFamily: 'Arial, sans-serif',
      textAlign: 'center'
    }}>
      <div> Processing authentication...</div>
     
    </div>
  );
};

export default AuthCallback;
